/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ embedded: NonNullable<unknown>, total: NonNullable<unknown> }} Activity_Center_Embedding_ProgressInputs */



/**
* | output |
* | --- |
* | "Indexed {embedded} / {total} files" |
*
* @param {Activity_Center_Embedding_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_embedding_progress = /** @type {((inputs: Activity_Center_Embedding_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Embedding_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.embedded} / ${i?.total} Dateien indiziert`)
	return /** @type {LocalizedString} */ (`Indexed ${i?.embedded} / ${i?.total} files`)
});